module.exports = __webpack_public_path__ + "static/img/hezuo_back1.1a7add6.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/hezuo_back1.png
// module id = y5ob
// module chunks = 0